"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Digitaldownload = function Digitaldownload(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "DigitaldownloadTitle DigitaldownloadDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "DigitaldownloadTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "DigitaldownloadDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M28.927 25.6v3.49c0 .973-.752 1.746-1.698 1.746H3.862c-.948 0-1.698-.77-1.698-1.745V25.6A.582.582 0 0 0 1 25.6v3.49C1 30.703 2.265 32 3.862 32h23.367c1.595 0 2.862-1.301 2.862-2.91V25.6a.582.582 0 0 0-1.164 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M22.35 19.363a.582.582 0 0 0-.823.015l-5.4 5.599V.582a.582.582 0 1 0-1.163 0v24.395l-5.4-5.6a.582.582 0 1 0-.837.809l6.4 6.637.004.002.007.009c.002 0 .002.002.003.004.02.017.043.025.063.04.028.02.055.042.086.058.01.004.018.014.028.018.003.002.007.002.01.003.036.014.073.016.11.023.034.007.067.02.103.02h.009c.035 0 .069-.013.103-.02.038-.007.074-.01.11-.023.003-.001.007-.001.01-.003.01-.004.017-.013.026-.017.032-.017.06-.039.089-.06.02-.014.043-.022.061-.04.002 0 .002-.002.003-.003l.008-.009.004-.002 6.4-6.637a.582.582 0 0 0-.015-.823"
  }));
};

Digitaldownload.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Digitaldownload.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Digitaldownload;
exports["default"] = _default;